import {
    Button, Divider, Icon, Stack, Box,
    Typography, FormControlLabel, Checkbox
} from '@mui/material'

import { Fragment, useEffect, useRef, useState } from 'react'

import { useSelector } from 'react-redux'

import { useLandingZoneMigration } from '@features/hooks/LandingZones/migration'

import Link from '@components/Link'
import Alert from '@components/Alert'

import RequestHelp from '@views/Landingzones/Migration/Components/RequestHelp'

export const Internet = () => {
    const dataStore = useSelector(state => state.landingZoneMigration)

    const { getStatus, handleNext, handlePrevious } = useLandingZoneMigration()

    const [inProgress, setInProgress] = useState(false)
    const [checked, setChecked] = useState(false)
    const [isInternetOnly, setIsInternetOnly] = useState(false)
    const [isCompleted, setIsCompleted] = useState(false)

    const timer = useRef()

    useEffect(() => {
        timer.current = setInterval(checkInterval, 10000)
        return () => { clearInterval(timer.current) }
    }, [])

    useEffect(() => {
        setInProgress(dataStore.selected.inProgress)
        setIsInternetOnly(dataStore.selected.lzType === 'LZ_INTERNET')
        setIsCompleted(dataStore.selected.isCompleted)
    }, [dataStore.selected])

    const checkInterval = () => {
        getStatus(dataStore.selected.lzId, false)
    }

    return (
        <Fragment>
            <Divider sx={{mt: 2}}/>
            <Box sx={{p: 2}}>
                <Typography variant={'h5'} sx={{mb: 1}}>Internet Migration</Typography>
                
                {(!inProgress) && (
                    <Fragment>
                        
                        <Typography variant={'body1'} sx={{mb: 2, lineHeight: 1.8}}>
                            The inter landing zones flows have been migrated successfully! To make sure everything went correctly, you can check the state of the following resources:
                        </Typography>

                        <Box component="ul" sx={{mb: 2, pl: 3}}>
                            <li>
                                <Typography variant={'body2'} sx={{mb: 1}}>
                                    <strong>Landing zone default route table(s)</strong> <code>udr-iasp-&lt;region&gt;-lz-network</code>: you should see that new routes have been created. These inter-lz routes are routing the remote LZ IP ranges to a new IP, which is the vWAN firewall
                                </Typography>
                            </li>
                        </Box>

                        <Typography variant={'body1'} sx={{mb: 2, lineHeight: 1.8}}>
                            If it's correct, you can now perform the internet migration. This step will redirect all the outbound traffic to the vWAN firewall, which means changing the Next Hop of all routes routing to the hub firewall to the vWAN firewall.
                        </Typography>

                        <FormControlLabel
                            control={<Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)} />}
                            label={<Stack direction={'row'} alignItems={'center'}><span>I confirm my application is</span>&nbsp;<Link external target={'_blank'} href={'https://digitalplatforms.totalenergies.com/documentation/platforms/azure-platform/inoxscale-platform/user-communication/major-network-change#required-actions-to-prepare-migration'}>ready to migrate</Link></Stack>}
                        />

                        <Alert sx={{mt: 2}} severity={'warning'} title={'Prepare you to a short interruption of service.'} />
                    </Fragment>
                )}

                {inProgress && (<Alert severity={'info'} title={'Internet migration is in progress'} />)}

                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{mt: 2}}>
                    <RequestHelp />
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'end'} spacing={1}>
                        <Button variant={'secondary'} startIcon={<Icon>undo</Icon>} disabled={inProgress} onClick={handlePrevious}>Rollback</Button>
                        {(!isInternetOnly || !isCompleted) && (
                            <Button startIcon={<Icon>sync_alt</Icon>} onClick={handleNext} disabled={(!checked || inProgress)}>Migrate</Button>
                        )}
                    </Stack>
                </Stack>
            </Box>
        </Fragment>
    )
}

export default Internet